import { dayjs } from "@/utils/dayjs";
import { toNumber } from "@/utils/number";
import { Dayjs } from "dayjs";

type TCalculateSpecifiedSkillFirstRemainingTermParams = {
  specifiedSkillFirstStartDate: Dayjs | string | null | undefined;
  blankPeriodMonthly: string | null | undefined;
};

export const calculateSpecificSkillTransitionPeriod = ({
  specifiedSkillFirstStartDate,
  blankPeriodMonthly,
}: TCalculateSpecifiedSkillFirstRemainingTermParams) => {
  const FIVE_YEARS_IN_MONTHS = 5 * 12; // 60 months

  if (!specifiedSkillFirstStartDate) {
    return { period: "", yearPeriod: 0, monthPeriod: 0, remainingMonths: FIVE_YEARS_IN_MONTHS };
  }

  const startDate = dayjs(specifiedSkillFirstStartDate);
  const blankPeriod = toNumber(blankPeriodMonthly) || 0;

  const today = dayjs().add(1, "day");

  const expiryDate = startDate.add(5, "year").add(blankPeriod, "month");

  if (expiryDate.isBefore(today) || expiryDate.isSame(today, "day")) {
    return { period: "0ヶ月", yearPeriod: 0, monthPeriod: 0, remainingMonths: 0 };
  }

  let yearDiff = expiryDate.year() - today.year();
  let monthDiff = expiryDate.month() - today.month();

  if (today.date() > expiryDate.date()) {
    monthDiff -= 1;
  }

  if (monthDiff < 0) {
    yearDiff -= 1;
    monthDiff += 12;
  }

  const yearPeriod = Math.max(0, yearDiff);
  const monthPeriod = Math.max(0, monthDiff);
  const remainingMonths = yearPeriod * 12 + monthPeriod;

  let period = "";
  if (yearPeriod > 0) {
    period += yearPeriod + "年";
  }
  if (monthPeriod > 0) {
    period += monthPeriod + "ヶ月";
  }
  if (!period) {
    period = "0ヶ月";
  }

  return {
    period,
    yearPeriod,
    monthPeriod,
    remainingMonths,
  };
};
